import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './SocialLinks.module.css';
export const SocialLinks = ({ title, links, className = '', 'data-testid': dataTestId, }) => {
    const getSocialIcon = (platform) => {
        switch (platform) {
            case 'linkedin':
                return _jsx(Icon, { name: 'linkedin', alt: 'LinkedIn' });
            case 'youtube':
                return _jsx(Icon, { name: 'youtube', alt: 'YouTube' });
            case 'facebook':
                return _jsx(Icon, { name: 'facebook', alt: 'Facebook' });
            case 'instagram':
                return _jsx(Icon, { name: 'instagram', alt: 'Instagram' });
            default:
                return null;
        }
    };
    const getPlatformName = (platform) => {
        switch (platform) {
            case 'linkedin':
                return 'LinkedIn';
            case 'youtube':
                return 'Youtube';
            case 'facebook':
                return 'Facebook';
            case 'instagram':
                return 'Instagram';
            default:
                return '';
        }
    };
    const renderSocialLink = (link, index) => {
        const trimmedLabel = link.label?.trim();
        const ariaLabel = trimmedLabel && trimmedLabel.length > 0 ? trimmedLabel : link.platform;
        return (_jsxs("a", { href: link.href, target: '_blank', rel: 'noopener noreferrer', className: styles.socialLink, "aria-label": ariaLabel, "data-testid": `${dataTestId || 'social-links'}-item-${index}`, children: [_jsx("div", { className: styles.socialIcon, "data-testid": `${dataTestId || 'social-links'}-icon-${index}`, children: getSocialIcon(link.platform) }), _jsx("span", { className: styles.socialText, "data-testid": `${dataTestId || 'social-links'}-text-${index}`, children: getPlatformName(link.platform) })] }, link.id));
    };
    return (_jsxs("section", { className: `${styles.container} ${className}`, "data-testid": dataTestId || 'social-links', children: [_jsx("h2", { className: styles.title, "data-testid": `${dataTestId || 'social-links'}-title`, children: title }), _jsx("div", { className: styles.socialGrid, "data-testid": `${dataTestId || 'social-links'}-grid`, children: links.map((link, index) => renderSocialLink(link, index)) })] }));
};
